(function () {
  'use strict';

  angular
      .module('tfc.retailer.Consumer')
      .controller('ConsumerProfileCtrl', ConsumerProfileCtrl);

  // @ngInject
  function ConsumerProfileCtrl($state, ageData, genderData, heightData, weightData, userBrands, ConsumerProfileReport,
                               CookieJar, filters, $stateParams, Enums, GaUtil, aggregationLogDetails,
                               inseamData, bustSizeData, footLengthData, Filter) {
    var vm = this;

    vm.brands = userBrands;
    vm.selectedBrand = _.find(vm.brands, {key: $state.params.brandKey });
    vm.rawAgeData = _.sortBy(ageData.age, 'range');
    vm.rawGenderData = genderData;
    vm.rawHeightData = _.sortBy(heightData.height, function(height){return toNumericValue(height.range) });
    vm.rawWeightData = _.sortBy(weightData.weight, function(weight){return toNumericValue(weight.range) });
    vm.rawInseamData = _.sortBy(inseamData.inseam, function(inseam){return toNumericValue(inseam.range) });
    vm.rawBustSizeData = _.sortBy(bustSizeData.bustSize, function(bustSize){return toNumericValue(bustSize.range) });
    vm.rawFootLengthData = _.sortBy(footLengthData.footLength, function(footLength){return toNumericValue(footLength.range) });
    vm.aggregationDetails = aggregationLogDetails;

    function toNumericValue(label) {
      var labelSplit = label.split(" ");
      var head = (labelSplit.length > 1) ? _.head(labelSplit) : (label === "Unspecified")? Number.POSITIVE_INFINITY: parseFloat(label.substring(0, label.indexOf('-')));
      var tail = (labelSplit.length > 1) ? _.toInteger(_.last(labelSplit)): (label === "Unspecified")? Number.POSITIVE_INFINITY : parseFloat(label.substring(0, label.indexOf('-')));
      if(head === "<") return tail - 1.0;
      else if(head === ">") return tail + 1.0;
      else return tail
    }

    vm.color = "#7C0A40";
    vm.weightUnit = ['kg', 'lb'];
    vm.lengthUnit = ['cm', 'in'];
    vm.selectedWeightUnit = angular.copy(vm.weightUnit[1]);
    vm.selectedHeightUnit = angular.copy(vm.lengthUnit[1]);
    vm.selectedInseamUnit = angular.copy(vm.lengthUnit[1]);
    vm.selectedBustSizeUnit = angular.copy(vm.lengthUnit[1]);
    vm.selectedFootLengthUnit = angular.copy(vm.lengthUnit[1]);

    vm.options = {
      horizontal : true,
      horizontalLabelSize : 40,
      verticalLabelSize : 15,
      barSpacing : .5,
      popupLabels: false,
      hideBarLabels : true,
      dashedLabelBoxes : true,
      hideTotalLabels : false
    };

    vm.genders = getGenderArr();

    function getGenderArr() {
      var genderArr = [];
      if (vm.rawGenderData.menPercent) {
        genderArr.push({
          name: 'Male',
          value: vm.rawGenderData.menPercent,
          display: 'Male - ' + toPercentLabel('of consumers', vm.rawGenderData.menPercent)
        });
      }
      if (vm.rawGenderData.womenPercent) {
        genderArr.push({
          name: 'Female',
          value: vm.rawGenderData.womenPercent,
          display: 'Female - ' + toPercentLabel('of consumers', vm.rawGenderData.womenPercent)
        });
      }
      return genderArr;
    }

    vm.selectedGender = _.find(vm.genders, {name: (!$stateParams.gender) ? 'Female' : $stateParams.gender});

    vm.activityRegionFilters = filters;

    var selectedTransaction = vm.activityRegionFilters && vm.activityRegionFilters.getSelected();
    var selectedRegion = selectedTransaction && selectedTransaction.getSelectedRegion();

    vm.selectActivityAndReload = function(activity){
      selectedTransaction = activity;
      GaUtil.sendGaEvent(vm.selectedBrand.key, 'Activity Filter', activity.label);
      vm.reload(false, true, true);
    };

    vm.selectRegionAndReload = function (region) {
      selectedRegion = region;
      GaUtil.sendGaEvent(vm.selectedBrand.key, 'Region Filter', region.labelDescription);
      vm.reload(false, false, true);
    };

    vm.setHeight = function () {
      var filteredData = _.filter(vm.rawHeightData, function(d) {
        return d.unit === vm.selectedHeightUnit;
      });
      setData('heightData', filteredData);
    };

    vm.setWeight = function () {
      var filteredData = _.filter(vm.rawWeightData, function(d) {
        return d.unit === vm.selectedWeightUnit;
      });
      setData('weightData', filteredData);
    };

    vm.setInseam = function () {
      var filteredData = _.filter(vm.rawInseamData, function(d) {
        return d.unit === vm.selectedInseamUnit;
      });
      setData('inseamData', filteredData);
    };

    vm.setFootLength = function () {
      var filteredData = _.filter(vm.rawFootLengthData, function(d) {
        return d.unit === vm.selectedFootLengthUnit;
      });
      setData('footLengthData', filteredData);
    };

    vm.setBustSize = function () {
      var filteredData = _.filter(vm.rawBustSizeData, function(d) {
        return d.unit === vm.selectedBustSizeUnit;
      });
      setData('bustSizeData', filteredData);
    };

    vm.setAll = function () {
      setData('ageData', vm.rawAgeData);
      vm.setHeight();
      vm.setWeight();
      vm.setBustSize();
      vm.setFootLength();
      vm.setInseam();
    };

    vm.selectedBrandReload = function(selectedBrand){
      vm.selectedBrand = selectedBrand;
      vm.reload(true, true, true);
    }

    vm.reload = function(resetActivity, resetRegion, resetGender) {
      CookieJar.set({ name: 'tfc-insight-selected-brand', value : _.toString(vm.selectedBrand.key)});

      var gender = (!resetGender) ? vm.selectedGender && vm.selectedGender.name: null;
      if(resetActivity && resetRegion && resetGender){ // on brand reload
        $state.go('.', { brandKey : vm.selectedBrand.key }, {inherit: false}, { reload : 'consumerReports' });
      }else {
        $state.go('.', {
          brandKey : vm.selectedBrand.key,
          gender: gender,
          transaction: selectedTransaction && selectedTransaction.getLabel(),
          region: selectedRegion && selectedRegion.getLabel()
        }, { reload : 'consumerReports.ConsumerProfile' });
      }
    };

    function toPercentLabel(label, value) {
      return value.toFixed(1) + '%\n  ' + label;
    }

    vm.downloadReport = function(type){
      ConsumerProfileReport.downloadReport(type, vm.selectedBrand.key, vm.selectedGender && vm.selectedGender.name,
          vm.selectedHeightUnit, vm.selectedWeightUnit, vm.selectedInseamUnit, vm.selectedFootLengthUnit,
          vm.selectedBustSizeUnit, vm.activityRegionFilters.getSelected() &&
          selectedRegion && selectedRegion.getLabel(),
          selectedTransaction && selectedTransaction.getLabel(),
          vm.activityRegionFilters && vm.activityRegionFilters.hasMultipleActivity(),
          selectedTransaction && selectedTransaction.hasMultipleRegion());
    };

    function setData(source, rawData, other) {
      var percentFn = _.property('percent');

      var valueFn, colorFn, genderSlice;

      if(vm.selectedGender && vm.selectedGender.name){
        valueFn = percentFn;
        colorFn = vm.color;
        genderSlice = vm.selectedGender.name;
      }

      vm[source] = _.defaultsDeep(other, vm[source], {
        dontRank : true,
        fn : {
          label : _.property('range'),
          stackLabel : genderSlice
        }
      });

      //dont update in defaultsDeep
      vm[source].fn.value = valueFn;
      vm[source].fn.color = colorFn;
      vm[source].fn.valueLabel = valueFn;
      vm[source].data = rawData;
      vm[source].pageSize = rawData.length;
    }

    vm.setAll();

    vm.getFilterSummaryText = function(){
      var pageName = 'consumer';
      var params = {
        'gender': vm.selectedGender && vm.selectedGender.name,
        'name': vm.selectedBrand.name,
        'activity': vm.activityRegionFilters && vm.activityRegionFilters.hasMultipleActivity() ? selectedTransaction && selectedTransaction.getLabel() : '',
        'region': selectedTransaction && selectedTransaction.hasMultipleRegion() ? selectedRegion && selectedRegion.labelDescription : ''
      };
      return Filter.getFilterSummaryText(pageName, params);
    }

  }
})();